import { IControlState } from "../../common/ui-form";
import { ControlState } from "../../common/ui-form/control-state";

export interface IFacilitatorSchoolControlState {
    schoolName: IControlState,
    mobileNumber: IControlState,
    userName: IControlState,
    password: IControlState,
    state: IControlState,
    address: IControlState,
    foundationPrograms: IControlState,
    olympiadExams: IControlState,
    chairmanName:IControlState,
    chairmanWhatsAppContact:IControlState,
    principalName:IControlState,
    principalWhatsAppContact:IControlState,
    programInChargeName:IControlState,
    programInchargeWhatsAppContact:IControlState

}

export class FacilitatorSchoolControlState
    implements IFacilitatorSchoolControlState {
    userName: IControlState = new ControlState();
    email: IControlState = new ControlState();
    schoolName: IControlState = new ControlState();
    mobileNumber: IControlState = new ControlState();
    password: IControlState = new ControlState();
    state: IControlState = new ControlState();
    address: IControlState = new ControlState();
    foundationPrograms: IControlState = new ControlState();
    olympiadExams: IControlState = new ControlState();
    chairmanName:IControlState = new ControlState();
    chairmanWhatsAppContact= new ControlState();
    principalName= new ControlState();
    principalWhatsAppContact= new ControlState();
    programInChargeName= new ControlState();
    programInchargeWhatsAppContact= new ControlState();
}

export interface IDeleteSchoolUserRequest {
    userId: number;
}